import {
    getAccountBySourceId,
    getSelectedAccount,
    setSelectedAccount,
} from 'owa-account-source-list-store';
import { errorThatWillCauseAlertAndThrow } from 'owa-trace';

import { preSelectAccount } from './pluggableHost';

export function getSelectedSourceId(): string {
    let currentSelected = getSelectedAccount();
    if (!currentSelected) {
        errorThatWillCauseAlertAndThrow('NoAccountSelected');
    }

    return currentSelected!.sourceId;
}

export async function setSelectedSourceId(sourceId: string): Promise<void> {
    const accountToSelect = getAccountBySourceId(sourceId);
    if (!accountToSelect) {
        errorThatWillCauseAlertAndThrow('SelectedAccountNotFound');
    }

    await preSelectAccount(sourceId);

    setSelectedAccount(sourceId);
}
